<template>
    <div class="report_container">
       <div class="mileage">
           <div class="unit_container">
                <span>
                {{reportData.totalMileage?reportData.totalMileage:0}}<span class="unit">km</span>
                </span>
           </div>
           
       </div>
       <div class="consume">
          <div class="time_unit">共耗时
              <span class="time">{{reportData.totalDrivingDuration?this.filterTimer(1,reportData.totalDrivingDuration):0}}</span><span>d</span>
              <span class="time">{{reportData.totalDrivingDuration?this.filterTimer(2,reportData.totalDrivingDuration):0}}</span><span>h</span>
              <span class="time">{{reportData.totalDrivingDuration?this.filterTimer(3,reportData.totalDrivingDuration):0}}</span><span>m</span>
            </div>
          <div class="progress"></div>
          <div class="speed">
              <div>平均速度{{reportData.avgSpeed?reportData.avgSpeed:0}}km/h</div>
              <div>最高速度{{reportData.maxSpeed?reportData.maxSpeed:0}}km/h</div>
          </div>
       </div>
       <div class="calendar" :class="reportData.length>30?'Hcalendar':'zcalendar'">
           <div class="calendar_top">
               <div class="top_md">
                   <span class="month">{{monthlyDate.split('-')[1]}}</span>
                   <span class="date">{{monthlyDate.split('-')[0]}}</span>
               </div>
               <div class="top_right">
                   <div>
                       <span class="work"></span>
                       <span>出勤</span>
                    </div>
                   <div class="top_idle">
                       <span class="idle"></span>
                       <span>空闲</span>
                    </div>
               </div>
           </div>
           <div class="calendar_content">
               <ul>
                   <li v-for="(item,index) in calendarData" :key="index" :style="item.calendar>0?'background-image: linear-gradient(102deg, #00B8B6 0%, #1AD196 100%);':''" 
                   :class="index%5==0?'active':index%4==0?'lastActive':'unActive'">
                       <span class="ca_date" :class="[item.calendar>0?'':showcActive]">{{item.time.split('-')[2]}}</span>
                       <span class="calendarNum" v-if="item.calendar>0">{{item.calendar>0?item.calendar:''}}</span>
                    </li>
               </ul>
           </div>
       </div>
       <div class="car_info">
           <div class="drive_num">
               <span class="car_num">{{reportData.drivingCount}}</span>
               <span class="desc">行驶次数</span>
           </div>
           <div class="start_mileage">
               <span class="car_num">{{reportData.startMileage}}<span class="unit">km</span></span>
               <span class="desc">起始里程</span>
           </div>
           <div class="end_mileage">
               <span class="car_num">{{reportData.endMileage}}<span class="unit">km</span></span>
               <span class="desc">结束里程</span>
           </div>
       </div>
       <div class="stop_car">
           <div class="flag">
           </div>
           <div class="stop_right">
               <div class="top">
                    <!-- <span class="top_flag"></span> -->
                    <span class="tit">停车</span>
                    <span class="num">累计停车 {{reportData.parkCount}} 次</span>
                </div>
                <div class="stop_time">
                    <p class="desc">累计时长</p>
                    <p>
                        {{this.filterTimer(1,reportData.totalParkDuration)}}<span>D</span>{{this.filterTimer(2,reportData.totalParkDuration)}}<span>h</span>{{this.filterTimer(3,reportData.totalParkDuration)}}<span>m</span>
                    </p>
                </div>
                <div class="large_time">
                    <span class="time_flag"></span>
                    <span class="desc">期间停车时长最长</span>
                    <span class="time">
                        {{this.filterTimer(1,reportData.maxParkDuration)}}<span>D</span>{{this.filterTimer(2,reportData.maxParkDuration)}}<span>h</span>{{this.filterTimer(3,reportData.maxParkDuration)}}<span>m</span>
                    </span>
                </div>
           </div>
           
       </div>
       <div class="speed_info">
            <div class="flag">
            </div>
           <div class="speed_right">
               <div class="top">
                    <span class="tit">超速</span>
                    <span class="num">累计超速 {{reportData.speedingCount}} 次</span>
                </div>
                 <div class="speed_data">
                    <div class="s_data">
                        <p>最高速度</p>
                        <p class="data_num">
                            {{reportData.speedingMaxSpeed}}<span>km/h</span>
                        </p>
                    </div>
                    <div class="over_speed">
                        <p>超速里程</p>
                        <p class="data_num">
                            {{reportData.speedingMileage}}<span>km</span>
                        </p>
                    </div>
                    <div class="over_time">
                        <p>超速时长</p>
                        <p class="data_num">
                            {{this.filterTimer(1,reportData.totalSpeedingDuration)}}<span>D</span>{{this.filterTimer(2,reportData.totalSpeedingDuration)}}<span>h</span>{{this.filterTimer(3,reportData.totalSpeedingDuration)}}<span>m</span>
                        </p>
                    </div>
                </div>
                <G2View v-if="overSpeedData.length>0" :speedData="overSpeedData"></G2View>
           </div>
            
        </div>
       <div class="speed_info idleSpeed">
            <div class="flag">
            </div>
           <div class="speed_right">
               <div class="top">
                    <span class="tit">怠速</span>
                    <span class="num">累计怠速 {{reportData.idleCount}} 次</span>
                </div>
                 <div class="stop_time">
                    <p class="desc">累计时长</p>
                    <p>
                       {{this.filterTimer(1,reportData.totalIdleDuration)}}<span>D</span>{{this.filterTimer(2,reportData.totalIdleDuration)}}<span>h</span>{{this.filterTimer(3,reportData.totalIdleDuration)}}<span>m</span>
                    </p>
                </div>
                <div class="large_time">
                    <span class="time_flag"></span>
                    <span class="desc">期间怠速时长最长</span>
                    <span class="time">{{this.filterTimer(1,reportData.maxIdleDuration)}}<span>h</span>{{this.filterTimer(2,reportData.maxIdleDuration)}}<span>m</span>
                    </span>
                </div>
           </div>
        </div>
        <div class="speed_info fatDrive">
            <div class="flag">
            </div>
            <div class="speed_right">
               <div class="top">
                    <span class="tit">疲劳驾驶</span>
                    <span class="num">累计 {{reportData.fatigueCount}} 次</span>
                </div>
                 <div class="stop_time">
                    <p class="desc">累计时长</p>
                    <p>
                        {{this.filterTimer(1,reportData.totalFatigueDuration)}}<span>D</span>{{this.filterTimer(2,reportData.totalFatigueDuration)}}<span>h</span>{{this.filterTimer(3,reportData.totalFatigueDuration)}}<span>m</span>
                    </p>
                </div>
                <div class="large_time">
                    <span class="time_flag"></span>
                    <span class="desc">疲劳驾驶时长最长</span>
                    <span class="time">{{this.filterTimer(1,reportData.maxFatigueDuration)}}<span>h</span>{{this.filterTimer(2,reportData.maxFatigueDuration)}}<span>m</span>
                    </span>
                </div>
            </div>
        </div>
         <div class="speed_info oil_container">
            <div class="flag">
            </div>
            <div class="speed_right">
               <div class="top">
                    <span class="tit">油量</span>
                </div>
                <ul class="oliList">
                    <li>
                        <p class="tit">累计加油</p>
                        <p class="oilNum">{{reportData.totalAddOil?reportData.totalAddOil:0}}<span>L</span></p>
                    </li>
                    <li class="useOil">
                        <p class="tit">累计用油量</p>
                        <p class="oilNum">{{reportData.totalOil?reportData.totalOil:0}}<span>L</span></p>
                    </li>
                    <li class="lossOil">
                        <p class="tit">累计漏油</p>
                        <p class="oilNum">{{reportData.totalOilLeakage?reportData.totalOilLeakage:0}}<span>L</span></p>
                    </li>
                    <li>
                        <p class="tit">百公里油耗</p>
                        <p class="oilNum">{{reportData.mpg?reportData.mpg:0}}</p>
                    </li>
                </ul>
                <div class="oilProData">
                    <ul class="proTitList">
                        <li>漏油量</li>
                        <li>用油量</li>
                        <li>加油量</li>
                    </ul>
                    <div class="viewPro">
                        <div class="wView" :style="{'padding-right':`${(500+maxOil-reportData.totalOilLeakage)/100}%`}">
                            <div class="innerView"  v-show="reportData.totalOilLeakage>0" :style="{width:`${reportData.totalOilLeakage}`}"></div>
                        </div>
                        <div class="wView" :style="{'padding-right':`${(500+maxOil-reportData.totalOil)/100}%`}">
                            <div class="innerView" v-show="reportData.totalOil>0" :style="{width:`${reportData.totalOill}`}"></div>
                        </div>
                        <div class="wView" :style="{'padding-right':`${(500+maxOil-reportData.totalAddOil)/100}%`}">
                            <div class="innerView" v-show="reportData.totalAddOil>0" :style="{width:`${reportData.totalAddOil}`}"></div>
                        </div>
                    </div>
                </div>
                <div class="rang">
                    <span>0</span><span>{{maxOil}}</span>
                </div>
            </div>
        </div>
        <div class="speed_info useCar">
             <div class="flag">
            </div>
            <div class="speed_right">
               <div class="top">
                    <span class="tit">用车情况</span>
                    <span class="num">累计 {{reportData.carOrderCount?reportData.carOrderCount:0}} 次</span>
                </div>
                 <div class="stop_time">
                    <p class="desc">累计公里数</p>
                    <p class="dis">
                        {{reportData.totalCarOrderMileage?reportData.totalCarOrderMileage:0}}<span>km</span>
                    </p>
                    <div class="line"></div>
                </div>
                <div class="large_time">
                    <span class="time_flag"></span>
                    <span class="desc">用车距离最长</span>
                    <span class="time">{{reportData.maxCarOrderMileage?reportData.maxCarOrderMileage:0}}<span>h</span>
                    </span>
                </div>
            </div>
        </div>
        <div class="speed_info carBuin">
              <div class="flag">
            </div>
            <div class="speed_right">
               <div class="top">
                    <span class="tit">车务情况</span>
                </div>
                <ul class="buin_container">
                    <li v-for="(item,index) in this.carBuinList" :class="[bunIndex==index?active:'']" :key="index" @click="toggle(index)">{{item}}</li>
                </ul>
                <div class="bunList">
                    <ul v-show="bunIndex==0">
                        <li>
                            <p class="bun_num">{{reportData.fuelCount}}</p>
                            <p class="bun_desc">加油次数</p>
                        </li>
                         <li>
                            <p class="bun_num">{{reportData.fuelVolumeCount}}<span>L</span></p>
                            <p class="bun_desc">加油量</p>
                        </li>
                         <li>
                            <p class="bun_num"><span>￥</span>{{reportData.fuelFeeCount}}</p>
                            <p class="bun_desc">加油费用</p>
                        </li>
                    </ul>
                     <ul v-show="bunIndex==1">
                        <li>
                            <p class="bun_num">{{reportData.motCount}}</p>
                            <p class="bun_desc">年检次数</p>
                        </li>
                         <li>
                            <p class="bun_num"><span>￥</span>{{reportData.motFeeCount}}</p>
                            <p class="bun_desc">年检费用</p>
                        </li>
                    </ul>
                     <ul v-show="bunIndex==2">
                        <li>
                            <p class="bun_num">{{reportData.repairCount}}</p>
                            <p class="bun_desc">维修次数</p>
                        </li>
                         <li>
                            <p class="bun_num"><span>￥</span>{{reportData.repairFeeCount}}</p>
                            <p class="bun_desc">维修费用</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
       data(){
           return{
               carBuinList:['加油情况','年检情况','维修情况'],
               active:'bunActive',
               showcActive:'show_cdata',
               bunIndex:0,
               reportData:[],
               calendarData:[],
               overSpeedData:[],
               maxOil:0,
               monthlyDate:'',
               plateNumber:''
           }
       },
       components:{
           'G2View':()=>import('./g2/index')
       },
       mounted(){
            this.monthlyDate=this.$route.query.monthlyDate
            this.plateNumber=this.$route.query.plateNumber
            // console.log(this.monthlyDate)
            // console.log(this.plateNumber)
            // this.monthlyDate='2020-10-01'
            // this.plateNumber='皖SIB597'
           this.getCarReport()
       },
       methods:{
           toggle(index){
               this.bunIndex=index;
           },
           async getCarReport(){
                // let rdata={
                //    plateNumber:'皖SIB597',
                //    monthlyDate:"2020-10-01"
                // }
                let rdata={
                   plateNumber:this.plateNumber,
                   monthlyDate:this.monthlyDate+'-01'
                }
               const resdata = await this.$api.getCarReport(rdata);
               this.reportData=resdata.datas.content;
                let max=this.reportData.totalAddOil>this.reportData.totalOilLeakage?this.reportData.totalAddOil:this.reportData.totalOilLeakage
               this.maxOil=max>this.reportData.totalOil?max:this.reportData.totalOil;
               let overSpeed=[];
               let calendar=[];
               for(var i in resdata.datas.content.calendarData){
                   calendar.push({time:i,calendar:resdata.datas.content.calendarData[i]})
               }
               for(var i in resdata.datas.content.calendarSpeeding){
                    overSpeed.push({time:i,speed:parseFloat(resdata.datas.content.calendarSpeeding[i])})
                }
                this.calendarData=this.calendarSort(calendar)
                this.calendarSort(overSpeed).map(item=>{
                    this.overSpeedData.push({time:item.time.split('-')[2],speed:item.speed})
                })
           },
           filterTimer(type,data){
                let day = parseInt(data / 60 / 60 / 24)
                let hours = parseInt(data / 60 / 60 % 24)
                let min = parseInt(data / 60 % 60)
                if(type==1){
                    return day;
                }
                else if(type==2){
                    return hours
                }else{
                    return min
                }
           },
            calendarSort(arr) {
                var len = arr.length;
                for (var i = 0; i < len-1; i++) {
                    for (var j = 0; j < len - 1 - i; j++) {
                        // 相邻元素两两对比，元素交换，大的元素交换到后面
                        if (parseInt(arr[j].time.split('-')[2]) > parseInt(arr[j + 1].time.split('-')[2])) {
                            var temp = arr[j];
                            arr[j] = arr[j+1];
                            arr[j+1] = temp;
                        }
                    }
                }
                return arr;
            }
       }
    }
</script>

<style lang="scss" scoped>
.active{
    margin-left: 0px;
}
.lastActive{
    margin-left: 10px;
}
.unActive{
    margin-left:7px;
}
.Hcalendar{
    height: 340px;
}
.zcalendar{
    height: 294px;
}
.show_cdata{
    height: 100%;
    line-height: 32px;
}
.bunActive{
    position: relative;
    background-image: linear-gradient(90deg, #39D995 0%, #00B3A0 95%) !important;
    border: 1px solid #05AC95;
    color:#FFFFFF !important;
}
.bunActive::after{
    position: absolute;
	left: 42px;
	top: 33px;
	display: block;
	content: "";
	width: 0;
	height: 0;
	border: 10px solid rgba(0,0,0,0);
	border-top-color:rgba(57,217,149,1);
}
.report_container{
    padding:0 15px;
    background: #2B3350;
    height:2361px;
    padding-top: 36px;
    overflow: hidden;
    .flag{
            height: 100%;
            width: 8px;
            margin-top:9px;
            margin-right: 10px;
            border-top: 4px solid #00B38A;;
    }
    .top{
        margin-bottom: 15px;
        .tit{
            display: inline-block;
            font-family: 'PingFangSC-Medium';
            font-size: 17px;
            color: #FFFFFF;
            margin-right: 10px;
        }
        .num{
            font-family: 'PingFangSC-Regular';
            font-size: 11px;
            color: #979EB5;
        }
    }
    .stop_time{
            margin-bottom: 25px;
            p{
                font-family: 'DINAlternate-Bold';
                font-size: 20px;
                color: #FFFFFF;
                span{
                    font-family: 'PingFangSC-Regular';
                    font-size: 10px;
                }
            }
            .desc{
                font-family: 'PingFangSC-Regular';
                font-size: 13px;
                color: #979EB5;
                margin-bottom: 8px;
            }

        }
        .large_time{
            .time_flag{
                display: inline-block;
                width: 6px;
                height: 6px;
                border-radius: 50%;
                background: #00B38A;
                margin-right: 10px;
            }
            .desc{
                display: inline-block;
                font-family: 'PingFangSC-Regular';
                font-size: 12px;
                color: #979EB5;
                margin-right: 3px;
            }
            .time{
                font-family: 'PingFangSC-Regular';
                font-size: 20px;
                color: #00B38A;
                span{
                    font-size: 10px;
                }
            }
        }
    .mileage{
        width: 368px;
        height: 70px;
        margin:0 auto;
        text-align:center;
        line-height: 70px;
        font-family: 'DINAlternate-Bold';
        font-size: 52px;
        color: #FFFFFF;
        margin-bottom: 31px;
        background-image: url('~@/assets/carReport/report.png');
        background-repeat: no-repeat;
        background-position: center;
        background-size: 368px 70px;
        .unit_container{
            width: 100%;
            height: 78px;
            margin:0 auto;
            background: url('~@/assets/carReport/report_bor.png') no-repeat center center;
            background-size: 200px 78px;
        }
        .unit{
            font-family: 'PingFangSC-Regular';
            font-size: 14px;
            color: #FFFFFF;
        }
    }
    .consume{
        margin-bottom:30px;
        .time_unit{
            font-family: 'PingFangSC-Medium';
            font-size: 17px;
            color: #FFFFFF;
            span{
                font-family: 'PingFangSC-Regular';
                font-size: 16px;
                color: #FFFFFF;
                letter-spacing: 0;
            }
            .time{
                font-family: 'DINAlternate-Bold';
                font-size: 26px;
            }
        }
        .progress{
            margin:7px 0;
            height: 4px;
            background-image: linear-gradient(-64deg, #FA6400 5%, #F7B500 45%, #6DD400 100%);
        }
        .speed{
            display: flex;
            justify-content: space-between;
            font-family: 'PingFangSC-Regular';
            font-size: 12px;
            color: #FA6400;
           :first-child{
               color: #FFFFFF;
               opacity: 0.5;
           }
        }
    }
    .calendar{
        margin-bottom: 37px;
        .calendar_top{
            display: flex;
            justify-content: space-between;
            margin-bottom: 23px;
            .top_md{
                  font-family: 'DINAlternate-Bold';
                  color: #FFFFFF;
                .month{
                    font-size: 18px;
                }
                .date{
                    margin-left: 5px;
                    font-size: 14px;
                }
            }
            .top_right{
                font-family: 'PingFangSC-Medium';
                font-size: 12px;
                color: #FFFFFF;
                display: flex;
                .top_idle{
                    margin-left: 15px;
                }
                .work,.idle{
                    display: inline-block;
                    width: 6px;
                    height: 6px;
                    border-radius: 50%;
                    background: #16CD9A;
                    margin-right: 5px;
                }
                .idle{
                   background: #2B3350;
                    border: 1px solid #485276;
                }
            }
        }
        .calendar_content{
            font-family: 'DINAlternate-Bold';
            font-size: 14px;
            color: #FFFFFF;
            // height: 194px;
            ul{
                li{
                    width: 70px;
                    height: 40px;
                    float: left;
                    text-align: center;
                    // line-height: 28px;
                    margin-bottom: 7px;
                    background: #2B3350;
                    border: 1px solid #485276;
                    border-radius: 20px;
                    box-sizing: border-box;
                    padding-top: 3px;
                    .ca_date{
                        font-size: 15px;
                        color: #FFFFFF;
                        display: block;
                    }
                    .calendarNum{
                        margin-top: 1px;
                        font-size: 12px;
                        color: #FFFFFF;
                        display: block;
                    }
                }
                :first-child{
                    margin-left: 0px;
                }
            }
        }
    }
    .car_info{
        width: 100%;
        margin-bottom: 20px;
        // margin-top: 35px;
        background: #272F4B;
        border-radius: 12px;
        height: 68px;
        display: flex;
        flex: 1;
        box-sizing: border-box;
        padding-top: 15px;
        div{
            display: flex;
            height: 40px;
            flex-direction: column;
            text-align: center;
            box-sizing: border-box;
            // padding:12px 0;
            .car_num{
                font-family: 'DINAlternate-Bold';
                font-size: 20px;
                color: #FFFFFF;
                margin-bottom: 4px;
                .unit{
                    font-family: 'PingFangSC-Regular';
                    font-size: 10px;
                    color: #FFFFFF;
                }
            }
            .desc{
                font-family: 'PingFangSC-Regular';
                font-size: 12px;
                color: #979EB5;
            }
        }
        .drive_num{
            width: 126px;
        }
        .start_mileage{
            width:136px;
            border-left: 1px solid rgba(151,151,151,0.3);
            border-right: 1px solid rgba(151,151,151,0.3);
        }
        .end_mileage{
            width: 120px;
        }
    }
    .stop_car{
        height: 170px;
        box-sizing: border-box;
        padding:15px 0 25px 0;
        background: #272F4B;
        display: flex;
        border-radius: 12px;
        margin-bottom: 15px;
    }
    .speed_info{
        height: 355px;
        display: flex;
        background: #272F4B;
        border-radius: 12px;
        padding-top:15px;
        .speed_right{
            .top{
                margin-bottom: 28px;
            }
            .speed_data{
            display: flex;
            height: 40px;
            margin-bottom: 36px;
            p{
                font-family: 'PingFangSC-Regular';
                font-size: 17px;
                color: #979EB5;
            }
            .data_num{
                font-family: 'DINAlternate-Bold';
                font-size: 20px;
                color: #FFFFFF;
                margin-top:6px;
                span{
                    font-family: 'PingFangSC-Regular';
                    font-size: 10px;
                }
            }
            .s_data{
                width: 105px;
            }
            .over_speed{
                width: 125px;
                box-sizing: border-box;
                padding-left:30px;
                border-left: 1px solid rgba(151,151,151,0.3);
                border-right: 1px solid rgba(151,151,151,0.3);
            }
            .over_time{
                box-sizing: border-box;
                padding-left:30px;
                width: 127px;
            }
        }
        }
       
    }
    .idleSpeed,.fatDrive{
        height: 170px;
        margin-top: 15px;
        .speed_right{
            .top{
                margin-bottom: 17px;
            }
        }
    }
    .oil_container{
        height: 313px;
        margin-top:15px;
        .speed_right{
            .top{
                margin-bottom: 25px;
            }
        }
        .oliList{
            width: 100%;
            height: 40px;
            li{
                width: 90px;
                height: 100%;
                float: left;
                box-sizing: border-box;
                padding-left:12px;
                border-right: 1px solid rgba(151,151,151,0.3);
                .tit{
                    font-size: 13px;
                    color: #979EB5;
                    margin-bottom: 6px;
                }
                .oilNum{
                    font-size: 20px;
                    color: #FFFFFF;
                    span{
                        color: #979797;
                        font-size: 10px;
                    }
                }
            }
            .useOil{
                width: 100px;
            }
            .lossOil{
                width: 80px;

            }
            :first-child{
                padding-left: 0;
            }
            :last-child{
                // width: 83px;
                // padding-right: 0;
                border-right: none;
            }
        }
        .oilProData{
            width: 100%;
            height: 145px;
            display: flex;
            margin-top: 23px;
            .proTitList{
                width:52px;
                height: 100%;
                box-sizing: border-box;
                padding-right: 10px;
                li{
                    float: left;
                    font-size: 12.5px;
                    color: #979EB5;
                    margin-top: 25px;
                }
            }
            .viewPro{
                width: 293px;
                height: 100%;
                box-sizing: border-box;
                padding-left: 8px;
                border-left: 1px solid #414C73;
                border-bottom: 1px solid #414C73;
                overflow: hidden;
                .wView{
                    width: 285px;
                    max-width: 285px !important;
                    height: 18px;
                    margin-top:22px;
                    background: #374165;
                    border-radius: 23px;
                    box-sizing: border-box;
                    overflow: hidden;
                    .innerView{
                        height: 100%;
                        background-image: linear-gradient(102deg, #00B8B6 0%, #1AD196 100%);
                        border-radius: 12px;
                        overflow: hidden;
                    }
                }
            }
        }
        .rang{
            display: flex;
            justify-content: space-between;
            box-sizing: border-box;
            padding-left:52px;
            margin-top: 5px;
            font-size: 12.5px;
            color: #979EB5;
        }
    }
    .useCar{
        margin-top: 15px;
        height: 170px;
        .speed_right{
            .top{
                margin-bottom: 15px;
            }
            .stop_time{
                margin-bottom: 14px;
                .dis{
                    font-size: 20px;
                    color: #FFFFFF;
                    span{
                        font-size: 10px;
                    }
                }
                .line{
                    margin-top:7px;
                    height: 4px;
                    width: 330px;
                    background-image: linear-gradient(102deg, #00B8B6 0%, #1AD196 100%);
                }
            }
        }
    }
    .carBuin{
        height: 203px;
        margin-top: 15px;
        .speed_right{
            .top{
                 margin-bottom: 25px;
            }
        }
        .buin_container{
            height: 36px;
            margin-bottom: 14px;
            li{
                float: left;
                width: 109px;
                height: 36px;
                background: #374165;
                border-radius: 3.5px;
                font-size: 15px;
                color: #C9CDD9;
                text-align:center;
                line-height: 36px;
                margin-right: 12.5px;
            }
            :last-child{
                margin-right: 0;
            }
        }
        .bunList{
            width: 350px;
            height: 60px;
            background: #374165;
            border-radius: 0 0 17px 17px;
            ul{
                display: flex;
                justify-content: space-around;
                height: 100%;
                box-sizing: border-box;
                padding-top: 9px;
                li{
                    .bun_num{
                        font-size: 20px;
                        color: #FFFFFF;
                        margin-bottom: 4px;
                    }
                    .bun_desc{
                        font-size: 13.5px;
                        color: #979EB5;
                    }
                    p{
                        text-align: center;
                        span{
                            font-size: 10px;
                            color: #FFFFFF;
                        }
                    }
                }
            }
        }
    }
}
</style>